<div
  [formGroup]="form"
  class="checkbox-container new-design"
>
  <div *ngFor="let checkbox of checkboxes">
    <mat-checkbox
      id="'mat' + {{checkbox.name}}"
      formControlName="{{checkbox.value}}"
      (change)="updateCheckbox(checkbox)"
    ></mat-checkbox>
    <label
      class="checkbox-label"
      for="'mat' + {{checkbox.name}}"
    ><span>{{ checkbox.name }}</span></label>
  </div>
</div>
